module.exports = __webpack_public_path__ + "static/media/react1Consumer.7151933c.png";